import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

interface EngagementChannel {
  channel: string;
  count: number;
}

export interface ProspectAccountWithHighEngagement {
  account_id: string;
  account_name: string;
  account_type: string;
  total_recent_inbound_engagement: number;
  total_prior_inbound_engagement: number;
  growth_percentage: number;
  engagement_channels: EngagementChannel[];
}

/**
 * Hook for fetching prospect accounts (without opportunities) that have high recent engagement growth
 * @param days The number of days in each comparison period (default: 7)
 * @param limit The maximum number of results to return (default: 5)
 */
export function useProspectAccountsWithHighEngagement(
  days: number = 7,
  limit: number = 5,
) {
  return useQuery<ProspectAccountWithHighEngagement[]>({
    queryKey: [
      "datahub",
      "accounts",
      "prospects-with-high-engagement",
      { days, limit },
    ],
    queryFn: async () => {
      const params = new URLSearchParams({
        days: days.toString(),
        limit: limit.toString(),
      });

      return api.get<ProspectAccountWithHighEngagement[]>(
        `datahub/accounts/prospects-with-high-engagement/?${params}`,
      );
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
